import PropTypes from "prop-types";
import React from 'react';
import { defaultTemplate } from "core/hoc";
import ApplicationTypeValidationTemplate from './ApplicationTypeValidationTemplate';
import { Content } from 'core/layouts';
import { BaasicButton } from "core/components";
import { observer } from 'mobx-react';
import AdditionalValidationModalTemplate from "./AdditionalValidationModalTemplate";

function ValidationModalTemplate({woundOrderAddWoundDressingViewStore}){
    return(
        <Content>
            {woundOrderAddWoundDressingViewStore.hasValidations && !woundOrderAddWoundDressingViewStore.hasCompletedAdditionalValidations && (
                <AdditionalValidationModalTemplate 
                    woundOrderAddWoundDressingViewStore={woundOrderAddWoundDressingViewStore}
                />
            )}
            {!woundOrderAddWoundDressingViewStore.hasValidations && !woundOrderAddWoundDressingViewStore.hasCompletedAdditionalValidations &&( 
                <Content>
                    <div className="modal__eligibility__header">
                        <div>
                            <h3 className="modal__eligibility__header--title">Check Eligibility</h3>
                            <h3 className="modal__eligibility__header--subtitle">Check completed</h3>        
                        </div>
                    </div>
                    <div className="modal__eligibility__body">
                        There are no required additional validations. Please proceed.
                    </div>
                    <div className="modal__eligibility__footer">
                        <BaasicButton
                            className='btn btn--med btn--secondary'
                            label="Cancel"
                            onClick={() => woundOrderAddWoundDressingViewStore.closeApplicationTypeValidationModal()}
                        />
                        <BaasicButton 
                            className='btn btn--med btn--secondary'
                            label="Order Review"
                            onClick={() => woundOrderAddWoundDressingViewStore.submitAdditionalValidations()}
                        />     
                    </div>
                </Content>
            )}
            {woundOrderAddWoundDressingViewStore.hasCompletedAdditionalValidations && !woundOrderAddWoundDressingViewStore.hasCompletedDressingComboValidation && 
            !woundOrderAddWoundDressingViewStore.showProceedToDispensingOrderButton && (
                <ApplicationTypeValidationTemplate 
                woundOrderAddWoundDressingViewStore={woundOrderAddWoundDressingViewStore}
                />
            )}

            {woundOrderAddWoundDressingViewStore.hasCompletedAdditionalValidations && woundOrderAddWoundDressingViewStore.showProceedToDispensingOrderButton && (
                <Content>
                    <div className="modal__eligibility__header">
                        <div>
                            <h3 className="modal__eligibility__header--title">Validations</h3>
                            <h3 className="modal__eligibility__header--subtitle">All validations completed</h3>        
                        </div>
                    </div>
                    <div className="modal__eligibility__body">
                        You have completed all validations. Please proceed to the dispensing order page.
                    </div>
                    <div className="modal__eligibility__footer">
                        <BaasicButton
                            className='btn btn--med btn--secondary'
                            label="Complete later"
                            onClick={() => woundOrderAddWoundDressingViewStore.closeApplicationTypeValidationModal()}
                        />
                        <BaasicButton 
                            className='btn btn--med btn--secondary'
                            label="Proceed"
                            onClick={() => woundOrderAddWoundDressingViewStore.goToDispensingOrderPage()}
                        />     
                    </div>
                </Content>
             )}
                
        </Content>
        
    );
}

ValidationModalTemplate.propTypes = {
    woundOrderAddWoundDressingViewStore: PropTypes.object,
    t: PropTypes.func 
};

export default defaultTemplate(ValidationModalTemplate);